
export const scatterContainerId = 'cross-analysis-scatter-chart';
